import carouselMobile from './carouselMobile';

export default function activeMenuInternal() {
  const id = $('[data-menuinternal]').attr('id');
  $(`[data-menuinternal-name="${id}"]`).addClass('active');

  carouselMobile();
}